import React from 'react';
import { IconProps } from '../../types/icon';

const JsonAltIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/JsonAltIcon.png"
      alt="JSON File"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default JsonAltIcon;
